import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "role-group" }
const _hoisted_2 = { class: "role-user-count" }
const _hoisted_3 = {
  key: 1,
  class: "ion-text-center ion-padding"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeaderWithMenu = _resolveComponent("PageHeaderWithMenu")!
  const _component_ion_card_title = _resolveComponent("ion-card-title")!
  const _component_ion_card_header = _resolveComponent("ion-card-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_card_content = _resolveComponent("ion-card-content")!
  const _component_ion_card = _resolveComponent("ion-card")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_note = _resolveComponent("ion-note")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_PageHeaderWithMenu, {
        title: "Роли",
        scrolled: _ctx.headerScrolled
      }, null, 8, ["scrolled"]),
      _createVNode(_component_ion_content, {
        class: _normalizeClass([_ctx.isMobile ? 'main-background' : 'liga-web-background']),
        fullscreen: true,
        onIonScroll: _ctx.onContentScroll
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                      _createTextVNode("Список ролей", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  (_ctx.allAuthorities.length > 0)
                    ? (_openBlock(), _createBlock(_component_ion_list, {
                        key: 0,
                        class: "roles-list"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allAuthorities, (a) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              key: a.name,
                              class: "role-item",
                              lines: "full"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h3", null, _toDisplayString(a.name), 1),
                                    _createElementVNode("p", null, _toDisplayString(a.description || '—'), 1),
                                    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.groupLabel(a.groupId)), 1),
                                    _createElementVNode("p", _hoisted_2, "Пользователей: " + _toDisplayString(_ctx.userCount(a)), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_ion_button, {
                                  slot: "end",
                                  fill: "clear",
                                  size: "default",
                                  onClick: ($event: any) => (_ctx.openEdit(a)),
                                  disabled: !_ctx.canEdit(a),
                                  title: "Редактировать"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.pencilOutline }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled"]),
                                _createVNode(_component_ion_button, {
                                  slot: "end",
                                  fill: "clear",
                                  size: "default",
                                  color: "danger",
                                  onClick: ($event: any) => (_ctx.confirmDelete(a)),
                                  disabled: !_ctx.canDelete(a),
                                  title: "Удалить"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_icon, { icon: _ctx.trashOutline }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }, 8, ["onClick", "disabled"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }))
                    : (!_ctx.loadingRoles)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Нет ролей"))
                      : _createCommentVNode("", true),
                  (_ctx.loadingRoles)
                    ? (_openBlock(), _createBlock(_component_ion_spinner, {
                        key: 2,
                        name: "crescent",
                        class: "ion-padding"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ion_button, {
                    fill: "clear",
                    size: "small",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.loadRoles())),
                    disabled: _ctx.loadingRoles
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createTextVNode("Обновить", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("Добавить новую роль", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Имя роли (ROLE_XXX)",
                        "label-placement": "stacked",
                        modelValue: _ctx.newRoleName,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newRoleName) = $event)),
                        placeholder: "ROLE_NEW"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_input, {
                        label: "Описание",
                        "label-placement": "stacked",
                        modelValue: _ctx.newRoleDescription,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newRoleDescription) = $event)),
                        placeholder: "Отображаемое название"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_note, { class: "ion-padding-start ion-padding-end" }, {
                    default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                      _createTextVNode("Новые роли создаются только в группе «Допуск к программам».", -1)
                    ]))]),
                    _: 1
                  }),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createRole())),
                    disabled: !_ctx.newRoleName.trim()
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("Создать роль", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_card, { class: "admin-card" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_card_header, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_card_title, null, {
                    default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                      _createTextVNode("Кеш ролей пользователей", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_card_content, null, {
                default: _withCtx(() => [
                  _cache[15] || (_cache[15] = _createElementVNode("p", { class: "ion-text-wrap" }, "Обновить кеш ролей у всех пользователей (применяет изменения прав без повторного входа).", -1)),
                  _createVNode(_component_ion_button, {
                    expand: "block",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.refreshCache()))
                  }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("Обновить кеш ролей", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_modal, {
            "is-open": !!_ctx.editingRole,
            onDidDismiss: _ctx.closeEditModal,
            "css-class": "edit-role-modal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_header, { class: "edit-role-modal-header" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_toolbar, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_title, null, {
                        default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                          _createTextVNode("Редактировать роль", -1)
                        ]))]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_button, {
                            fill: "clear",
                            onClick: _ctx.closeEditModal
                          }, {
                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                              _createTextVNode("Отмена", -1)
                            ]))]),
                            _: 1
                          }, 8, ["onClick"]),
                          _createVNode(_component_ion_button, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveEdit())),
                            disabled: _ctx.savingEdit
                          }, {
                            default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                              _createTextVNode("Сохранить", -1)
                            ]))]),
                            _: 1
                          }, 8, ["disabled"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.editingRole)
                ? (_openBlock(), _createBlock(_component_ion_content, {
                    key: 0,
                    class: "edit-role-modal-content ion-padding"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { class: "edit-role-item" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [...(_cache[19] || (_cache[19] = [
                              _createTextVNode("Имя роли", -1)
                            ]))]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            value: _ctx.editingRole.name,
                            disabled: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { class: "edit-role-item" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_input, {
                            label: "Описание",
                            "label-placement": "stacked",
                            modelValue: _ctx.editDescription,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editDescription) = $event)),
                            placeholder: "Отображаемое название"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_item, { class: "edit-role-item" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_select, {
                            label: "Группа",
                            "label-placement": "stacked",
                            modelValue: _ctx.editGroupId,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editGroupId) = $event)),
                            interface: "popover"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_select_option, { value: 1 }, {
                                default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                  _createTextVNode("Группы прав (общие)", -1)
                                ]))]),
                                _: 1
                              }),
                              _createVNode(_component_ion_select_option, { value: 2 }, {
                                default: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                  _createTextVNode("Допуск к программам", -1)
                                ]))]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["is-open", "onDidDismiss"])
        ]),
        _: 1
      }, 8, ["class", "onIonScroll"])
    ]),
    _: 1
  }))
}